import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const VerifyEmail = () => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email) {
      setError('Email address not found. Please sign up again.');
      setLoading(false);
      return;
    }

    if (code.length !== 6) {
      setError('Please enter the 6-digit code');
      setLoading(false);
      return;
    }

    try {
      await axios.post(`${API_URL}/auth/verify-email`, {
        email,
        code
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err) {
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Failed to verify email. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!email) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <img src="/logo-auth.svg" alt="Venue IQ" className="auth-logo" />
          <h2>Email Verification</h2>
          <p style={{ color: '#e74c3c', marginBottom: '1rem' }}>
            No email address found. Please sign up first.
          </p>
          <button className="btn" onClick={() => navigate('/signup')}>
            Go to Sign Up
          </button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <img src="/logo-auth.svg" alt="Venue IQ" className="auth-logo" />
          <h2>Email Verified!</h2>
          <div style={{ color: '#27ae60', marginBottom: '1rem', textAlign: 'center' }}>
            <p>Your email has been verified successfully.</p>
            <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#666' }}>
              Your account is now pending admin activation. You will receive an email once your account is activated.
            </p>
            <p style={{ marginTop: '1rem', fontSize: '0.9rem', color: '#666' }}>
              Redirecting to login page...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <img src="/logo-auth.svg" alt="Venue IQ" className="auth-logo" />
        <h2>Verify Your Email</h2>
        <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '0.9rem' }}>
          We've sent a 6-digit verification code to <strong>{email}</strong>
        </p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="code">Verification Code</label>
            <input
              type="text"
              id="code"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="Enter 6-digit code"
              required
              maxLength="6"
              disabled={loading}
              style={{
                textAlign: 'center',
                fontSize: '1.5rem',
                letterSpacing: '0.5rem',
                fontWeight: 'bold'
              }}
            />
          </div>
          <button type="submit" className="btn" disabled={loading || code.length !== 6}>
            {loading ? 'Verifying...' : 'Verify Email'}
          </button>
        </form>
        <div className="auth-link" style={{ marginTop: '1rem' }}>
          Didn't receive the code? Check your spam folder or contact support.
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
